import { captureException, captureMessage } from "./sentry";

/**
 * Production-ready logger that uses Sentry when available, falls back to console.
 * Use this instead of console.log/error/warn throughout the application.
 */
export const logger = {
  /**
   * Log an error (sends to Sentry)
   */
  error: (message: string, error?: Error | unknown, context?: Record<string, any>) => {
    if (error instanceof Error) {
      captureException(error, {
        message,
        ...context,
      });
    } else if (error) {
      captureMessage(`${message}: ${String(error)}`, "error", {
        error: String(error),
        ...context,
      });
    } else {
      captureMessage(message, "error", context);
    }
  },

  /**
   * Log a warning (sends to Sentry)
   */
  warn: (message: string, context?: Record<string, any>) => {
    captureMessage(message, "warning", context);
  },

  /**
   * Log an info message (only in development, not sent to Sentry to avoid noise)
   */
  info: (message: string, ...args: any[]) => {
    // Only log to console in development
    if (import.meta.env.DEV) {
      console.log(`[INFO] ${message}`, ...args);
    }
  },

  /**
   * Log debug information (only in development, never sent to Sentry)
   */
  debug: (message: string, ...args: any[]) => {
    // Only log to console in development
    if (import.meta.env.DEV) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  },
};
